// extracted by mini-css-extract-plugin
module.exports = {"majorContainer":"Catalog_majorContainer__38chr","imgWrap1":"Catalog_imgWrap1__1sXjq","imgWrap2":"Catalog_imgWrap2__7VEr7"};